import styled from 'styled-components';
export const CircleSkeletonContainer = styled.div`
  width: ${_ref => {
  let {
    radius
  } = _ref;
  return radius ? radius * 2 : 50;
}}px;
  height: ${_ref2 => {
  let {
    radius
  } = _ref2;
  return radius ? radius * 2 : 50;
}}px;
  border-radius: 100%;
  background-color: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.neutralL3;
}};
  background-size: 200px 100%;
  background-repeat: no-repeat;
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0), rgb(255, 255, 255), rgba(0, 0, 0, 0));
  line-height: 1;
  opacity: 0.1;
  animation: 1s ease-in-out 0s infinite normal none running skeleton-loading;
  @keyframes skeleton-loading {
    0% {
      background-position: -200px 0;
    }
    100% {
      background-position: calc(200px + 100%) 0;
    }
  }
`;